import { ApiManager } from '@zoomit/web-kit';

import { ArticleSearchV2 } from '../../constants/apis';
import type { ArticlesSearchResultType } from '../../types/search';

export const searchArticle = async ({
  query,
  articlesPageSize,
  articlesPageNumber,
}: {
  query: string;
  articlesPageNumber?: number;
  articlesPageSize?: number;
}) => {
  const searchUrl = new URL(ArticleSearchV2);
  const params = new URLSearchParams({
    Query: query,
  });

  if (articlesPageNumber) {
    params.append('Articles.PageNumber', `${articlesPageNumber}`);
  }

  if (articlesPageSize) {
    params.append('Articles.PageSize', `${articlesPageSize}`);
  }

  searchUrl.search = params.toString();
  return await ApiManager.get<ArticlesSearchResultType>(searchUrl.toString());
};
